import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';

/**
 * @slot - Contents placed within the element
 */
@Component({
  tag: 'wb-grid',
  styleUrl: 'grid.scss',
  shadow: true,
})
export class GridComponent implements ComponentInterface {
  /** Attribute for a full-width grid */
  @Prop({ reflect: true })
  public fullWidth?: boolean = false;

  public render(): JSX.Element {
    return (
      <Host class="wb-grid">
        <slot />
      </Host>
    );
  }
}
